module.exports = __webpack_public_path__ + "img/Favicon_Logo.bc7fdb4a.svg";